<script>
import { PhxIcon } from '@phx-styleguides/iwc';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: { PhxIcon },

  props: {
    title: {
      type: String,
      default: null,
    },
  },

  computed: {
    ...mapGetters('wishlist', ['hasItemsInWishlistFromLocalStorage']),
  },

  created() {
    this.refreshWishlistFromLocalStorage();
  },

  methods: {
    ...mapActions('wishlist', ['loadWishlistProducts', 'refreshWishlistFromLocalStorage']),
  },
};
</script>

<template>
  <phx-icon :icon="hasItemsInWishlistFromLocalStorage ? 'bookmark-active' : 'bookmark'" :title="title" />
</template>
